<template>
  <div style="min-height: 100vh; position: relative">
    <div
      v-if="!selectedBot.status"
      style="
        position: absolute;
        z-index: 2;
        background-color: #ecececbd;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      "
    >
      <div class="text-xs-center mt-5 pt-5" style="margin-bottom: 25px">
        <v-card max-width="600" style="margin: auto">
          <v-card-text>
            <h2 style="text-shadow: 1px 1px 20px #9e9e9e" class="display-1">
              {{ $t('If you want to test, please activate your bot') }}
            </h2>
            <p>
              {{ $t('Information will not be recorded in analytics if the bot is inactivated') }}
            </p>

            <v-btn
              depressed
              style="margin-bottom: 1.5em"
              @click="toggleBotStatus"
              small
              color="primary"
              >{{ $t('Click for starting your Bot') }}</v-btn
            >
          </v-card-text>
        </v-card>
      </div>
    </div>

    <div class="pa-1">
      <stat-card v-model="total" :loading="loading">
        <template v-if="type == 'inbox'">
          {{ $t('Conversation') }}
        </template>
        <template v-else-if="type == 'comment'">
          <template v-if="commenttype == 'replycomment'">
            {{ $t('Reply to comment') }}
          </template>
          <template v-else-if="commenttype == 'replyinbox'">
            {{ $t('Reply to inbox') }}
          </template>
          <template v-else-if="commenttype == 'hidecomment'">
            {{ $t('Hide comment') }}
          </template>
        </template>
      </stat-card>
    </div>
    <v-layout wrap>
      <v-flex xs12 sm12 md12>
        <div class="pa-1">
          <v-card>
            <v-card-title>
              <v-layout>
                <v-flex>
                  <template v-if="type == 'inbox'">
                    {{ $t('Conversation') }}
                  </template>
                  <template v-else-if="type == 'comment'">
                    <template v-if="commenttype == 'replycomment'">
                      {{ $t('Reply to comment') }}
                    </template>
                    <template v-else-if="commenttype == 'replyinbox'">
                      {{ $t('Reply to inbox') }}
                    </template>
                    <template v-else-if="commenttype == 'hidecomment'">
                      {{ $t('Hide comment') }}
                    </template>
                  </template>
                </v-flex>
                <v-flex class="text-xs-right">
                  <!-- <v-btn small outline color="primary">{{$t('Export')}}</v-btn> -->
                </v-flex>
              </v-layout>
            </v-card-title>

            <dashboard-graph-loading v-if="loading"></dashboard-graph-loading>

            <div style="max-width: 350px; margin: auto">
              <apexchart
                v-if="intentSeries && intentSeries.length > 0"
                :key="timestamp"
                ref="intent"
                type="pie"
                :options="intent"
                :series="intentSeries"
                style="margin: auto"
              ></apexchart>
            </div>
            <v-divider></v-divider>
            <v-data-table
              v-bind:pagination.sync="pagination"
              :headers="intentHeaders"
              :items="intentChartData"
              :rows-per-page-items="[10, 25, 45, { text: $t('All'), value: -1 }]"
              :rows-per-page-text="$t('Rows per page')"
            >
              <template v-slot:items="props">
                <td>
                  <v-avatar :color="props.item.color" size="15"></v-avatar>
                </td>
                <td>
                  <template v-if="props.item.name == '{default}'">{{
                    $t('Default Conversation')
                  }}</template>
                  <template v-else-if="props.item.name == null">{{ $t('Other') }}</template>
                  <template v-else-if="props.item.name == '{welcome}'">{{
                    $t('Welcome Message')
                  }}</template>
                  <template v-else>{{ props.item.name }}</template>
                </td>
                <td>{{ props.item.value | numberFormat }}</td>
                <td v-if="props.item.name === '{default}'">
                  <v-btn outline small color="grey" @click="openIntentDetail(props.item.name)">
                    {{ $t('Training') }}
                  </v-btn>
                </td>
                <td v-else>
                  <v-btn
                    fab
                    icon
                    small
                    flat
                    color="grey"
                    @click="openIntentDetail(props.item.name)"
                  >
                    <v-icon>search</v-icon>
                  </v-btn>
                </td>
              </template>

              <template slot="no-data">
                <div class="text-xs-center">{{ $t('No conversation') }}</div>
              </template>
            </v-data-table>
          </v-card>
        </div>
      </v-flex>
    </v-layout>

    <v-dialog v-model="showIntent" v-if="currentIntent" scrollable>
      <v-card>
        <v-card-title>
          <template v-if="currentIntent == '{default}'">{{ $t('Default Conversation') }}</template>
          <template v-else-if="currentIntent == null">{{ $t('Other') }}</template>
          <template v-else-if="currentIntent == '{welcome}'">{{ $t('Welcome Message') }}</template>
          <template v-else-if="currentIntent == '{default_comment_to_inbox}'">{{
            $t('More Comment to Inbox')
          }}</template>
          <template v-else>{{ currentIntent }}</template>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px" class="pa-0">
          <div v-if="loadingIntent">
            <div class="text-xs-center" style="padding: 30px 0">
              <div class="spinner text-xs-center">
                <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
              </div>
            </div>
          </div>
          <div v-else-if="filterIntentDetail.length <= 0">
            <div class="text-xs-center" style="margin: 35px 0">
              <img src="/static/img/assets/setting/conversation.png" alt style="width: 230px" />
              <h2>{{ $t('Not found any chatlog') }}</h2>
              <!-- <p>test</p> -->
            </div>
          </div>
          <div v-else>
            <template v-if="intentDetails && intentDetails.length">
              <v-data-table :headers="modalIntentHeader" :items="intentDetails" hide-actions>
                <template v-slot:items="props">
                  <!-- <td>{{ props.item.name }}</td> -->
                  <td style="word-break: break-word">
                    {{ props.item.question_data ? props.item.question_data : $t('Other') }}
                  </td>
                  <td class="text-xs-center">{{ props.item.count | numberFormat }}</td>
                </template>
              </v-data-table>

              <div class="text-xs-center mt-5 mb-3" v-if="$store.getters.getPackage != 'premium'">
                <h2 style="text-shadow: 1px 1px 20px #9e9e9e">
                  {{ $t('Its time to upgrade.') }}
                </h2>
                <p style="text-shadow: 1px 1px 20px #9e9e9e">
                  {{
                    $t('Upgrade Your Plan to use {package} features , only {price} THB/month', {
                      price: packages.premium.price,
                      package: $t('PREMIUM')
                    })
                  }}
                </p>
                <v-btn
                  depressed
                  color="primary"
                  :to="'/' + $i18n.locale() + '/upgrade'"
                  v-if="selectedBot.pagetype != 'enterprise'"
                  >{{ $t('Upgrade to {package} Plan', { package: $t('PREMIUM') }) }}</v-btn
                >
              </div>
            </template>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outline color="grey" @click="showIntent = false">{{ $t('cancel') }}</v-btn>
          <v-btn depressed color="primary" :to="trainingUrl" v-if="currentIntent == '{default}'">{{
            $t('Training')
          }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'

import dayjs from 'dayjs'
import numeral from 'numeral'
import XLSX from 'xlsx'

import VueApexCharts from 'vue-apexcharts'

import StatCard from './StatCard'
import DashboardGraphLoading from './DashboardGraphLoading'

export default {
  props: ['type', 'date', 'app', 'commenttype', 'fbpost'],
  data: function() {
    return {
      packages: this.getPackageDetail(),
      timestamp: dayjs().format('x'),
      total: 0,
      loading: true,
      loadingThaiUnion: false,
      loadingIntent: true,
      showIntent: false,
      filter: 'all',
      currentIntent: undefined,
      currentIntentIndex: undefined,
      intentDetails: [],
      intentChartData: [],
      intentChart: undefined,
      modalIntentHeader: [
        { text: this.$t('customer says'), value: 'questiondata' },
        { text: this.$t('Count'), value: 'count', align: 'center' }
      ],
      intentHeaders: [
        { text: '', value: '', sortable: false },
        { text: this.$t('Conversation'), value: 'name' },
        { text: this.$t('Count'), value: 'value' },
        { text: '', value: 'view', sortable: false }
      ],
      commentHeaders: [
        { text: '', value: '', sortable: false },
        { text: this.$t('Conversation'), value: 'name' },
        { text: this.$t('Count'), value: 'value' },
        { text: '', value: 'view', sortable: false }
      ],
      pagination: { sortBy: 'value', descending: true, rowsPerPage: 10 },
      commentPagination: { sortBy: 'value', descending: true, rowsPerPage: 10 },
      commentChartData: [],

      intentSeries: [],
      commentSeries: [],

      intent: {
        chart: {
          type: 'donut',
          height: 350
        },
        labels: [],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                // width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }
        ],
        dataLabels: {
          enabled: true
        },
        legend: {
          show: false
        }
      },
      comment: {
        chart: {
          type: 'donut',
          height: 350
        },
        labels: [],
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                // width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }
        ],
        dataLabels: {
          enabled: true
        },
        legend: {
          show: false
        }
      }
    }
  },
  components: {
    DashboardGraphLoading,
    apexchart: VueApexCharts,
    StatCard
  },
  async mounted() {
    if (this.selectedBot.status) {
      this.loading = true
      var response = await this.getIntent()
      this.formatData(response)
      this.loading = false
    } else {
      this.loadingIntent = false
      this.loading = false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang',
      isCoachlab: 'isCoachlab'
    }),

    filterIntentDetail: function() {
      var vm = this
      return vm.intentDetails.sort(function(a, b) {
        if (a.training == true && b.training != true) {
          return 1
        }
        if (a.training != true && b.training == true) {
          return -1
        }

        return 0
      })
    },
    trainingUrl: function() {
      return (
        '/' +
        this.currentLang +
        '/training?datefrom=' +
        dayjs(this.date.start).format('YYYY-MM-DD') +
        '&dateto=' +
        dayjs(this.date.end).format('YYYY-MM-DD') +
        '&from=inbox'
      )
    }
  },
  methods: {
    getchatlogthaiunionformat() {
      var vm = this
      //thai union
      this.loadingThaiUnion = true
      api.getchatlogthaiunionformat(
        {
          pageid: this.selectedBot.pageid,
          datefrom: dayjs(this.date.start).format('YYYY-MM-DD'),
          dateto: dayjs(this.date.end).format('YYYY-MM-DD')
        },
        function(error, response) {
          if (error) {
            console.error(error)
            vm.loadingThaiUnion = false
            return
          }
          // console.log(response)
          if (response.responsecode == 200) {
            var json = []
            json = response.data.flatMap(el => {
              if (el.answerby == 'admin') {
                return [
                  {
                    Sender: el.answerby,
                    'facebook - line Name': el.facebookname,
                    empcode: el.empcode,
                    'User MessageType': el.messagetype,
                    'User Message': el.messagedata,
                    timestampDate: dayjs(el.timestamp).format('DD/MM/YYYY'),
                    timestampTime: dayjs(el.timestamp).format('HH:mm')
                  }
                ]
              } else {
                return [
                  {
                    Sender: 'customer',
                    'facebook - line Name': el.facebookname,
                    empcode: el.empcode,
                    'User MessageType': el.questiontype,
                    'User Message': el.questiondata,
                    timestampDate: dayjs(el.timestamp).format('DD/MM/YYYY'),
                    timestampTime: dayjs(el.timestamp).format('HH:mm')
                  },
                  {
                    Sender: el.answerby,
                    'facebook - line Name': 'Thai Union HR People Connect',
                    empcode: '',
                    'User MessageType': el.messagetype,
                    'User Message': el.messagedata,
                    timestampDate: dayjs(el.timestamp).format('DD/MM/YYYY'),
                    timestampTime: dayjs(el.timestamp).format('HH:mm')
                  }
                ]
              }
            })

            const dataWS = XLSX.utils.json_to_sheet(json)
            const wb = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(wb, dataWS)
            XLSX.writeFile(wb, 'zwizdata-thaiunion-conversation.xlsx')
          }
          vm.loadingThaiUnion = false
        }
      )
    },
    getIntent: function() {
      let vm = this
      let data = {
        body: {
          pageid: vm.selectedBot.pageid,
          from_date: dayjs(vm.date.start).format('YYYY-MM-DD'),
          to_date: dayjs(vm.date.end).format('YYYY-MM-DD'),
          app: vm.app
        }
      }

      vm.loading = true
      return new Promise(resolve => {
        if (vm.type == 'inbox') {
          api.post_report_inbox_message(data, function(error, response) {
            if (error) {
              console.error(error)
              vm.loading = false
              return
            }
            if (response.data) {
              vm.$store.dispatch('setReportInboxMessage', response)
              vm.total = response.total_message
              resolve(response.data.sort(vm.sortIntent))
            }
          })
        } else if (vm.type == 'comment') {
          data.body.type = vm.commenttype
          if (vm.fbpost) {
            data.body.question_source = this.fbpost.id
          }
          api.post_report_comment_message(data, function(error, response) {
            if (error) {
              console.error(error)
              vm.loading = false
              return
            }
            if (response.data) {
              if (vm.commenttype === 'replycomment') {
                vm.$store.dispatch('setReportReplyToComment', response)
              } else if (vm.commenttype === 'replyinbox') {
                vm.$store.dispatch('setReportReplyToInbox', response)
              } else if (vm.commenttype === 'hidecomment') {
                vm.$store.dispatch('setReportHideComment', response)
              }
              vm.total = response.total_count
              resolve(response.data.sort(vm.sortIntent))
            }
          })
        }
      })
    },
    formatData(data) {
      let conversations = {
        data: [],
        label: [],
        color: [],
        intentname: [],
        intents: []
      }
      if (data && data.length > 0) {
        conversations = data
          .map(val => {
            let current_color = this.getRandomColor()
            var label = ''
            if (val['intent'] === '{default}') {
              label = this.$t('Default Conversation')
            } else if (val['intent'] == null) {
              label = this.$t('Other')
            } else if (val['intent'] === '{welcome}') {
              label = this.$t('Welcome Message')
            } else if (val['intent'] === '{default_comment_to_inbox}') {
              label = this.$t('More Comment to Inbox')
            } else if (val['intent'] === '{default_comment_to_inbox}') {
              label = this.$t('More Comment to Inbox')
            } else {
              label = val['intent']
            }

            return {
              intent: {
                name: val['intent'],
                color: current_color,
                value: parseInt(val['count'])
              },

              intentname: val['intent'],
              label: label,
              count: parseInt(val['count']),
              color: current_color
            }
          })
          .reduce(
            (prev, curr) => {
              prev.data.push(curr.count)
              prev.label.push(curr.label)
              prev.intentname.push(curr.name)
              prev.color.push(curr.color)
              prev.intents.push(curr.intent)
              prev.count.push(curr.count)

              return prev
            },
            {
              data: [],
              label: [],
              intentname: [],
              color: [],
              intents: [],
              count: []
            }
          )
      }
      this.intentSeries = conversations.data
      this.intent.labels = conversations.label
      this.intent.intentname = conversations.intentname
      this.intent.colors = conversations.color

      this.intentChartData = conversations.intents

      this.$nextTick(function() {
        if (this.$refs.intent) {
          this.$refs.intent.updateOptions({
            colors: conversations.color,
            labels: conversations.label
          })
        }
        this.timestamp = dayjs().format('x')
      })
    },
    getRandomColor: function() {
      var letters = '0123456789ABCDEF'
      var color = '#'
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)]
      }
      return color
    },
    truncate: function(text, limit) {
      let length = text.length
      return text.substring(0, Math.min(limit, length)) + (length > limit ? '...' : '')
    },
    sortIntent: function(a, b) {
      // console.log(a.count)
      if (parseInt(a.count) < parseInt(b.count)) return 1
      if (parseInt(a.count) > parseInt(b.count)) return -1
      return 0
    },
    getTrainingConversation: function() {
      var vm = this
      var data = {
        pageid: vm.selectedBot.pageid,
        intent: vm.currentIntent,
        type: vm.type,

        from_date: dayjs(this.date.start).format('YYYY-MM-DD'),
        to_date: dayjs(this.date.end).format('YYYY-MM-DD'),
        app: this.app
      }
      vm.loadingIntent = true
      api.getGroupDefaultChatlogs(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.loadingIntent = false
          return
        }

        var intentDetail = []
        var current = null
        var count = 0
        if (response.data) {
          vm.intentDetails = response.data
        }
        vm.loadingIntent = false
      })
    },
    openIntentDetail: function(intentName) {
      if (intentName === '{default}') {
        this.$router.push(this.trainingUrl).catch(() => {})
      }
      var vm = this
      vm.currentIntent = intentName
      vm.loadingIntent = true
      vm.getTrainingConversation()
      vm.showIntent = true
    },
    exportDashboard: function() {
      let vm = this

      let csvContent = ''
      if (vm.loading) {
        return false
      }
      this.loading = true
      let json = []
      json.push([
        `${this.$t('from')} ` +
          dayjs(vm.date.start).format('DD/MM/YYYY') +
          ` ${this.$t('to')} ` +
          dayjs(vm.date.end).format('DD/MM/YYYY')
      ])

      json.push([])
      json.push([this.$t('Conversation')])
      json.push(['Name', 'Count', 'Percent'])

      var totalIntentMessage = 0
      vm.intent.labels.forEach(function(seriesData, index) {
        totalIntentMessage += vm.intentSeries[index]
      })

      vm.intent.labels.forEach(function(seriesData, index) {
        json.push([
          seriesData,
          numeral(vm.intentSeries[index]).format('0,0'),
          (totalIntentMessage > 0
            ? numeral((vm.intentSeries[index] * 100) / totalIntentMessage).format('0.0')
            : 0) + ' %'
        ])
      })
      json.push([])
      json.push([])
      json.push([this.$t('Reply to inbox')])
      json.push(['Name', 'Count', 'Percent'])

      var totalCommentMessage = 0
      vm.comment.labels.forEach(function(seriesData, index) {
        totalCommentMessage += vm.commentSeries[index]
      })

      vm.comment.labels.forEach(function(seriesData, index) {
        json.push([
          seriesData,
          numeral(vm.commentSeries[index]).format('0,0'),
          (totalCommentMessage > 0
            ? numeral((vm.commentSeries[index] * 100) / totalCommentMessage).format('0.0')
            : 0) + ' %'
        ])
      })

      const dataWS = XLSX.utils.aoa_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, 'zwizdata-summary-conversation.xlsx')
      this.loading = false
    },
    toggleBotStatus: async function() {
      let bot = Object.assign({}, this.selectedBot)
      bot.status = !bot.status
      this.$store.dispatch('loading')
      await this.$store.dispatch('toggleBotStatus', bot)
      this.$store.dispatch('loading')
    }
  },
  watch: {
    async app(newVal, oldVal) {
      if (newVal != oldVal) {
        if (this.selectedBot.status) {
          this.loading = true
          var response = await this.getIntent()
          this.formatData(response)
          this.loading = false
        } else {
          this.loadingIntent = false
          this.loading = false
        }
      }
    },
    async date(newVal, oldVal) {
      if (newVal != oldVal) {
        if (this.selectedBot.status) {
          this.loading = true
          var response = await this.getIntent()
          this.formatData(response)
          this.loading = false
        } else {
          this.loadingIntent = false
          this.loading = false
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/analytics/ReportMessageGraph.vue